<template>
  <div class="w3-white" v-if="activeInvoice">
    <div class="w3-row">
      <div class="w3-bar w3-white outline w3-hide-print">
        <div class="w3-bar-item" @click="back()"><i class="fas fa-times"></i> Back</div>
        <!-- TODO Pay Now -->
        <div class="w3-bar-item w3-right" :class="activeInvoice.status === 'paid' ? 'w3-text-light-grey':'w3-text-green'" @click="payInvoice()"><i class="fas fa-credit-card"></i> Pay Now</div>
        <!-- TODO Print Layout tweaks -->
        <div class="w3-bar-item w3-right" @click="window.print();"><i class="fas fa-print"></i> Print</div>
      </div>
    </div>
    <div class="w3-container">
      <div class="w3-bar dark" style="height:30px; margin: 30px 0 0; overflow:visible;">
        <div class="w3-bar-item w3-right w3-white" style="margin-top:-24px; margin-right:80px; padding:0 10px;">
            <span style="font-size:3.4em; text-transform:uppercase; letter-spacing:-2px">Invoice</span>
        </div>
      </div>

      <div class="w3-row-padding w3-font-16 w3-print-threecol invoiceInfo" style="margin-top:30px;">
        <div class="w3-third">
          <header class="w3-container">
            <h5><b>Details</b></h5>
          </header>
          <section>
            <div class="w3-bar-block">
              <div class="w3-bar-item">
                <div class="w3-col" style="width:80px;">
                  Status:<br/>
                  Invoice #:<br/>
                  Created:<br/>
                  Due:<br/>
                </div>
                <div class="w3-rest">
                  <span style="text-transform:capitalize;">{{activeInvoice.status}}</span><br/>
                  {{activeInvoice.number}}<br/>
                  {{activeInvoice.date | date}}<br/>
                  <span v-if="activeInvoice.due_date">{{activeInvoice.due_date | date}}</span><span v-else>-</span><br/>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="w3-third">
          <header class="w3-container">
            <h5><b>Pay To</b></h5>
          </header>
          <section>
            <div class="w3-bar-block">
              <div class="w3-bar-item">
                <p>Mobile Seven<br/>61 Magnolia Ave<br/>Ormond Beach, FL 32174</p>
              </div>
            </div>
          </section>
        </div>
        <div class="w3-third" v-if="state.user.email !== 'darren@gomobile7.com'">
          <header class="w3-container">
            <h5><b>Billed To</b></h5>
          </header>
          <section>
            <div class="w3-bar-block">
              <div class="w3-bar-item">
                <!-- TODO: fix billed to name (currently using logged in user, invoice data does not include client name and address) -->
                <span v-if="state.user.businessName !== ''">{{state.user.businessName}}<br/></span>
                <span v-else>{{state.user.displayName}}<br/></span>
                <span>{{state.user.address.address1}}<br/></span>
                <span v-if="state.user.address2">{{state.user.address2}}<br/></span>
                <span>{{state.user.address.city}}, {{state.user.address.state}}  {{state.user.address.zip}}</span>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="w3-row" style="margin-top:30px;">
        <table class="w3-table w3-bordered paymentMethodResults" :class="state.width > 1024 ? '' : 'w3-responsive'">
          <tr class="w3-light-grey">
            <th style="min-width:250px;">Item</th>
            <th class="w3-center" style="min-width:200px;">Period</th>
            <th class="w3-center" style="min-width:90px;">Price</th>
            <th class="w3-center" style="min-width:60px;">Qty</th>
            <th class="w3-center" style="min-width:90px;">Total</th>
          </tr>
          <tr v-for="(item, index) in activeInvoice.lines.data" :key="index" class="paymentRow">
              <td>{{item.description}}</td>
              <td class="w3-center">
                <span v-if="item.period.start !== item.period.end">{{item.period.start | date}} - {{item.period.end | date}}</span>
                <span v-else>N/A</span>
              </td>
              <td class="w3-center">{{item.amount / item.quantity / 100 | currency}}</td>
              <td class="w3-center">{{item.quantity}}</td>
              <td class="w3-center">{{item.amount / 100 | currency}}</td>
          </tr>
        </table>
      </div>
      <div class="w3-row-padding" style="margin-top:40px;">
        <div class="w3-half w3-font-16">Note:<br/>{{activeInvoice.description}}</div>
        <div class="w3-half">
          <div class="w3-bar w3-bar-block">
            <div class="w3-bar-item w3-right-align w3-font-20 w3-padding-0">
              <span style="margin-right:10px;">Subtotal:</span><span>{{activeInvoice.subtotal / 100 | currency}}</span>
            </div>
            <div class="w3-bar-item w3-right-align w3-font-20 w3-padding-0">
              <span style="margin-right:10px;">Total:</span><span>{{activeInvoice.total / 100 | currency}}</span>
            </div>
          </div>
        </div>
      </div>
      <template v-if="activeInvoice.charge">
        <div class="w3-margin-top outline w3-hide-print">
          <div class="w3-row">
            <div class="w3-bar dark">
              <div class="w3-bar-item">Related Transactions</div>
            </div>
          </div>
          <div class="w3-row" v-if="chargeData && chargeData.status">
            <table class="w3-table w3-bordered paymentMethodResults" :class="state.width > 1024 ? '' : 'w3-responsive'">
              <tr class="w3-light-grey">
                <th>Charge ID</th>
                <th class="w3-center" style="width:150px;">Amount</th>
                <th class="w3-center" style="width:70px;">Last 4</th>
                <th class="w3-center" style="width:70px;">Status</th>
              </tr>
              <tr class="paymentRow">
                <td>{{chargeData.id}}</td>
                <td class="w3-center">{{chargeData.amount / 100 | currency}}</td>
                <td class="w3-center">{{chargeData.source.last4}}</td>
                <td class="w3-center" v-if="chargeData.status === 'succeeded'">Completed</td>
                <td class="w3-center" v-else>{{chargeData.status}}</td>
              </tr>
            </table>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import dataStore from '@/dataStore';

export default {
  name: 'invoice-details',
  data() {
    return {
      state: dataStore.state,
      activeInvoice: dataStore.state.user.invoices.activeInvoice,
      chargeData: Object,
      window: window
    }
  },
  created() {
    if (this.activeInvoice) {
      if (this.activeInvoice.charge) {
        dataStore.getChargeDetails(this.activeInvoice.charge).then((res) => {
          if (res.data.code === 'success') {
            this.chargeData = res.data.data
          }
        })
      }
    }
  },
  methods: {
    payInvoice() {
      if (this.activeInvoice.status === 'paid') {
        console.log('already paid')
        return
      }
      console.log('TODO: pay invoice')
    },
    back() {
      if (this.$route.name === 'Invoices') {
        this.state.user.invoices.activeInvoice = {}
        this.state.invoicesView = 'list'
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped>
header img {height:30px; margin:8px 0;}
.rightButton {padding:6px 10px; margin:0 5px 0 0;}

.subtitle {
    position: relative;
}
.subtitle span {font-size:36px;}
.subtitle span:before, .subtitle span:after {
    position: absolute;
    top: 10px;
    width: 100%;
    height: 30px;
    content: '\a0';
    background-color: #00897b;
}
.subtitle span:before {
    margin-left: -110%;
    text-align: right;
}
.w3-bar-item p, .w3-container h5 {margin:0;}
.w3-bar-item .fas {margin-right:6px;}

.invoiceRow {cursor:pointer;}
.invoiceInfo .w3-bar-item {padding-left:8px;}

@media (max-width:600px) {
  .invoiceInfo .w3-bar-item {margin-bottom:16px;}
}

</style>



// WEBPACK FOOTER //
// src/system/templates/invoice-details.vue